import { render, staticRenderFns } from "./Recommandation.vue?vue&type=template&id=0ea60d32"
import script from "./Recommandation.vue?vue&type=script&lang=js"
export * from "./Recommandation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports